import { render, staticRenderFns } from "./TopoguideViewSmallLink.vue?vue&type=template&id=3fc820ab&scoped=true"
import script from "./TopoguideViewSmallLink.vue?vue&type=script&lang=js"
export * from "./TopoguideViewSmallLink.vue?vue&type=script&lang=js"
import style0 from "./TopoguideViewSmallLink.vue?vue&type=style&index=0&id=3fc820ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc820ab",
  null
  
)

export default component.exports